import person1 from './img/person-3.jpg'
import person2 from './img/person-4.jpg'
import person3 from './img/person-12.jpg'
import person4 from './img/person-22.jpg'
import person5 from './img/person-31.jpg'
const data =[
    {
        id: 1,
        img: person1,
        age: 27,
        name: "Bertie Yarnes"
    },
    {
        id: 2,
        img: person2,
        age: 24,
        name: "Sarah Yarnes"
    },
    {
        id: 3,
        img: person3,
        age: 24,
        name: "Young Besmit"
    },
    {
        id: 4,
        img: person4,
        age: 24,
        name: "Tim Clark"
    },
    {
        id: 5,
        img: person5,
        age: 24,
        name: "Claire Brossel"
    }
]


export default data